import {useContext} from 'react';
import {AuthContextState, IAuthContext} from '../context/AuthContext';
import {ISubscriptionContext, SubscriptionContextState} from "../context/SubscriptionContext";
import {ILanguageContext, LanguageContextState} from "../context/LanguageContext";

export const useLanguage = () => useContext<LanguageContextState>(ILanguageContext)